import { IRdcConsignmentDao } from 'core/api/types/rdc.interface';
import { useDialog } from 'core/providers/DialogProvider';
import ViewLocationDialog from 'modules/run-activity/dialogs/view-location-dialog';
import dayjs from 'dayjs';

interface IRdcOverviewDetails {
  consignment: IRdcConsignmentDao;
}

const RdcOverviewDetails = ({ consignment }: IRdcOverviewDetails) => {
  const dialog = useDialog();
  const { latitude, longitude } = consignment.location;

  const details: { key: string; label: string; value: string; onClick?: () => void }[] = [
    {
      key: 'destination',
      label: 'Destination',
      value: consignment.destination,
    },
    {
      key: 'createdBy',
      label: 'Created by',
      value: consignment.created.by.fullName,
    },
    {
      key: 'createdAt',
      label: 'Created at',
      value: dayjs(consignment.created.at.toDate()).format('DD/MM/YYYY HH:mm'),
    },
    {
      key: 'vehicle',
      label: 'Vehicle',
      value: consignment.vehicleRegistration || '-',
    },
    {
      key: 'recipient',
      label: 'Recipient',
      value: consignment.recipientName || '-',
    },
    {
      key: 'location',
      label: 'Location (lat, lng)',
      value: `${latitude}, ${longitude}`,
      onClick: () => dialog?.openDialog(<ViewLocationDialog position={consignment.location} />),
    },
    {
      key: 'photos',
      label: 'Photos',
      value: `${consignment.photoPaths?.length ?? 0}`,
    },
  ];

  return (
    <div className='flex-grow-0 flex-shrink-0 basis-[360px] bg-white shadow-md rounded-md'>
      <div className='border-b p-4 flex justify-between items-center'>
        <p className='headline-06'>Details</p>
      </div>
      <div className='p-4'>
        {details.map((section) => (
          <div key={section.key} className='mt-4 first:mt-0'>
            <p className='body-02 text-gray-500'>{section.label}</p>
            {section.onClick ? (
              <button
                type='button'
                onClick={section.onClick}
                className='body-01 break-words text-secondary hover:underline text-left'
              >
                {section.value}
              </button>
            ) : (
              <p className='body-01 break-words whitespace-pre-wrap'>{section.value}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RdcOverviewDetails;
